import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const EProcurementsSettingsComponent = ({ selectEProcurementSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Auto Approval Enabled"
                            name="IsAutoApprovalEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'PurchaseRequestSettings.IsAutoApprovalEnabled',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.IsAutoApprovalEnabled}
                        />
                        <InputContainer
                            label="Allowed To Modify ApprovedPO"
                            name="IsAllowedToModifyApprovedPO"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'PurchaseRequestSettings.IsAllowedToModifyApprovedPO',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.IsAllowedToModifyApprovedPO}
                        />
                        <InputContainer
                            label="No Of Days To Keep Draft Purchase Request"
                            name="NoOfDaysToKeepDraftPurchaseRequest"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PurchaseRequestSettings.NoOfDaysToKeepDraftPurchaseRequest',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="number"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.NoOfDaysToKeepDraftPurchaseRequest}
                        />
                        <InputContainer
                            label="Physical Stock Adjustment Number Prefix"
                            name="PHysicalStockAdjustmentNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PurchaseRequestSettings.PHysicalStockAdjustmentNumberPrefix',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.PHysicalStockAdjustmentNumberPrefix}
                        />
                        <InputContainer
                            label="Purchase Order Number Prefix"
                            name="PurchaseOrderNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PurchaseRequestSettings.PurchaseOrderNumberPrefix',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.PurchaseOrderNumberPrefix}
                        />
                        <InputContainer
                            label="Purchase Quote Number Prefix"
                            name="PurchaseQuoteNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PurchaseRequestSettings.PurchaseQuoteNumberPrefix',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.PurchaseQuoteNumberPrefix}
                        />
                        <InputContainer
                            label="Purchase Request Number Prefix"
                            name="PurchaseRequestNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PurchaseRequestSettings.PurchaseRequestNumberPrefix',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.PurchaseRequestNumberPrefix}
                        />
                        <InputContainer
                            label="Purchase Return Number Prefix"
                            name="PurchaseReturnNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PurchaseRequestSettings.PurchaseReturnNumberPrefix',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.PurchaseReturnNumberPrefix}
                        />
                        <InputContainer
                            label="Wastage Number Prefix"
                            name="WastageNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PurchaseRequestSettings.WastageNumberPrefix',
                                    selectEProcurementSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.PurchaseRequestSettings?.WastageNumberPrefix}
                        />
                    </div>
                }
                expandedPanel="PurchaseRequest Settings"
                headerTitle="PurchaseRequest Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="GRN Number Prefix"
                            name="GRNNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'GRNSettings.GRNNumberPrefix',
                                    selectEProcurementSettings?.GRNSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.GRNSettings?.GRNNumberPrefix}
                        />
                        <InputContainer
                            label="Allowed To Modify ApprovedGRN"
                            name="IsAllowedToModifyApprovedGRN"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'GRNSettings.IsAllowedToModifyApprovedGRN',
                                    selectEProcurementSettings?.GRNSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEProcurementSettings?.GRNSettings?.IsAllowedToModifyApprovedGRN}
                        />
                    </div>
                }
                expandedPanel="GRN Settings"
                headerTitle="GRN Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Indent Number Prefix"
                            name="IndentNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'StockTransferSettings.IndentNumberPrefix',
                                    selectEProcurementSettings?.StockTransferSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.StockTransferSettings?.IndentNumberPrefix}
                        />
                        <InputContainer
                            label="Note Number Prefix"
                            name="NoteNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'StockTransferSettings.NoteNumberPrefix',
                                    selectEProcurementSettings?.StockTransferSettings
                                )
                            }}
                            type="text"
                            value={selectEProcurementSettings?.StockTransferSettings?.NoteNumberPrefix}
                        />
                    </div>
                }
                expandedPanel="StockTransfer Settings"
                headerTitle="StockTransfer Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Internal Supplier Allowed"
                            name="IsInternalSupplierAllowed"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'SupplierSettings.IsInternalSupplierAllowed',
                                    selectEProcurementSettings?.SupplierSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEProcurementSettings?.SupplierSettings?.IsInternalSupplierAllowed}
                        />
                    </div>
                }
                expandedPanel="Supplier Settings"
                headerTitle="Supplier Settings"
            />
        </>
    )
}
export default EProcurementsSettingsComponent;
